export class IngestionPipelineDeadLetterByteRange {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "start",
            "baseName": "start",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "end",
            "baseName": "end",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineDeadLetterByteRange.attributeTypeMap;
    }
    constructor() {
    }
}
